import { makeStyles } from "@mui/styles";

export const styles = () => {
    return {
        formHeader: {
            display: "flex",
            justifyContent: "space-between",
        },
        tablePaper: {
            overflowY: "auto",
        },
        tablePaperLog: {
            maxHeight: "calc(100vh - 200px)",
            overflowY: "auto",
            width: "100%",
        },
        tableHeaderPaper: {
            padding: 5,
            boxShadow: "none",
        },
        table: {
            width: "100%",
        },
    };
};

export const listStyles = makeStyles(styles);
